export const areKeysPressed = (keys: string[] = [], keysPressed: Set<string> = new Set()): boolean => {
    const keysPressedArr = Array.from(keysPressed);
    const required = new Set(keys);
    for (var elem of keysPressedArr) {
        required.delete(elem);
    }
    return required.size === 0;
}